import ReactGA from 'react-ga4';
import { getUserDetails } from 'store';

const getCommonAnalyticsProperties = user => {
  if (!user) {
    return {};
  }

  const { chainName, emailId } = user;
  const domain = emailId?.slice(emailId.indexOf('@') + 1);

  return { chain_name: chainName, domain };
};

const getPageTitle = () => {
  const { pathname } = window.location;
  let pageTitle = document.title;

  if (pathname.includes('dashboard')) {
    pageTitle = 'homePage';
  } else if (pathname.includes('information')) {
    pageTitle = 'informationPage';
  } else if (pathname.includes('amenities')) {
    pageTitle = 'amenitiesPage';
  } else if (pathname.includes('guest-rooms')) {
    pageTitle = 'guestRoomsPage';
  } else if (pathname.includes('security')) {
    pageTitle = 'securityPage';
  } else if (pathname.includes('meeting-rooms')) {
    pageTitle = 'meetingRoomsPage';
  } else if (pathname.includes('restaurants')) {
    pageTitle = 'restaurantsPage';
  } else if (pathname.includes('policies')) {
    pageTitle = 'policiesPage';
  } else if (pathname.includes('attractions')) {
    pageTitle = 'attractionsPage';
  } else if (pathname.includes('images')) {
    pageTitle = 'imagesPage';
  }

  return pageTitle;
};

export const initializeGA = () => {
  ReactGA.initialize([
    // eslint-disable-next-line no-undef
    { trackingId: process.env.REACT_APP_GA_ID },
    { gtagOptions: { send_page_view: false } },
  ]);
};

export const pageViews = ({ properties = {} } = {}) => {
  const user = getUserDetails();

  // ReactGA.set
  ReactGA.send({
    hitType: 'pageview',
    title: getPageTitle(),
    ...getCommonAnalyticsProperties(user),
    ...properties,
  });
};

export const track = ({ category, action, label, properties = {} }) => {
  const user = getUserDetails();

  ReactGA.gtag('event', action, {
    event_category: category,
    event_label: label,
    ...getCommonAnalyticsProperties(user),
    ...properties,
  });
};
